import {Component, OnInit} from '@angular/core';

import {DynamicBarService} from "../../_components/dynamic-bar/dynamic-bar.service";

@Component({
    selector: 'nivelaciones-barra',
    standalone: false,
    template: `
        <div class="header-mainInfo">
            <!--<a class="control-item" href="/estudio/resumen" title="Ir a estudio">Estudio</a><span-->
                <!--class="header-mainInfo__separator">/</span>-->
            <h1 class="">Nivelaciones</h1>
            <span class="spacer"></span>
        </div>`
})

export class NivelacionesBarraComponent implements OnInit {
    constructor(private dynamicBarService: DynamicBarService) {
    }

    ngOnInit() {
    }
}